<!-- This HTML content is not displayed directly, but through ElementRef. -->
<div #archiveNotificationPopupContent style="display: none">
  <ng-container *transloco="let t">
    <!-- The "content-img" is styled in popup component. -->
    <img src="assets/img/support/archiveShowcase.png" [alt]="t('shared/archiveImageText')" class="content-img" />

    <p>
      {{ t('shared/archiveText1') }}
    </p>
    <p [innerHTML]="t('shared/archiveText2')"></p>
    <p [innerHTML]="t('shared/archiveText3')"></p>
  </ng-container>
</div>
